import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { Observable, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AlertMessageService } from './../../alert/alert-message/alert-message.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertRow } from '../../alert/alert-message/alert-row';



function isCritical(row: AlertRow): boolean {
    if (row.matchExpectation) {
        if (row.matchExpectation.type === 'confirmation') {
            return true;
        }
    } else {
        return true;
    }
    return false;
}


@Component({
    selector: 'app-alert-metric',
    templateUrl: './alert-metric.component.html',
    styleUrls: ['./alert-metric.component.css']
})
export class AlertMetricComponent implements OnInit, OnDestroy {
    criticalCount = 0;
    warningCount = 0;
    streamError = false;
    subscription: Subscription;

    constructor(private alertMessageService: AlertMessageService,
        private dashboardEventService: DashboardEventService) {
    }
    ngOnInit(): void {
        const rowStream: Observable<AlertRow[]> = this.alertMessageService.getAlertRowSubject()
            .pipe(catchError((err, caught) => {
                this.streamError = true;
                return [];
            }))
            .pipe(map((rows: AlertRow[]) => {
                this.streamError = false;
                this.criticalCount = 0;
                this.warningCount = 0;
                return rows
                    .map((row: AlertRow) => {
                        if (isCritical(row)) {
                            this.criticalCount++;
                        } else {
                            this.warningCount++;
                        }
                        return row;
                    });
            }));
        // Empty subscription?
        this.subscription = rowStream.subscribe({ next: () => { } });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    filterFunction(rows: AlertRow[]): AlertRow[] {
        return rows
            .filter((row: AlertRow) => {
                return isCritical(row);
            })
            .sort((row1: AlertRow, row2: AlertRow) => {
                return row2.expectedTimeMoment.diff(row1.expectedTimeMoment, 'minutes');
            })
            .slice(0, 3);
    }


    zoomToAlerts() {
        this.dashboardEventService.alertSelectionSubject.next('zoom');
    }



}
